/*
 * @Description:
 * @Date: 2020-11-12 13:42:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:35:54
 */

const hexify = color => {
  var values = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',');
  var a = parseFloat(values[3] || 1),
    r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
    g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
    b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
  return (
    '#' +
    ('0' + r.toString(16)).slice(-2) +
    ('0' + g.toString(16)).slice(-2) +
    ('0' + b.toString(16)).slice(-2)
  );
};
const colorRgb = (str, opacity) => {
  var sColor = str.toLowerCase();
  if (sColor) {
    if (sColor.length === 4) {
      var sColorNew = '#';
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
    }
    return hexify('rgba(' + sColorChange.join(',') + ',' + opacity + ')');
  } else {
    return sColor;
  }
};
const emptyArr = new Array(2).fill('');
export const colorArr = emptyArr.reduce(pre => {
  pre = pre.concat([
    (opacity = 1) => colorRgb('#685FFF', opacity),
    (opacity = 1) => colorRgb('#E8B100', opacity),
    (opacity = 1) => colorRgb('#7FB5FF', opacity),
    (opacity = 1) => colorRgb('#A7E6F1', opacity),
    (opacity = 1) => colorRgb('#BEA2FF', opacity),
    (opacity = 1) => colorRgb('#FF9460', opacity)
  ]);
  return pre;
}, []);

export const darkColorArr = emptyArr.reduce(pre => {
  pre = pre.concat([
    (opacity = 1) => colorRgb('#453EBF', opacity),
    (opacity = 1) => colorRgb('#E69500', opacity),
    (opacity = 1) => colorRgb('#5EA2FF', opacity),
    (opacity = 1) => colorRgb('#77D5E5', opacity),
    (opacity = 1) => colorRgb('#A882FF', opacity),
    (opacity = 1) => colorRgb('#FF7532', opacity)
  ]);
  return pre;
}, []);

export const colorMixOpacity = (color, opacity = 1) => colorRgb(color, opacity);
